<template>
  <div>
    <v-btn
      fab
      bottom
      right
      color="pink"
      dark
      fixed
      @click.stop="dialog = !dialog"
    >
      <v-icon>add</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" width="800px">
      <v-card>
        <v-card-title
          class="grey lighten-4 py-4 title"
        >
          Add Role
        </v-card-title>
        <v-container grid-list-sm class="pa-4">
          <v-layout align-center row wrap>
            <v-flex xs12 align-center justify-space-between>
              <v-text-field
                placeholder="Role name"
                v-model="modelName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 align-center justify-space-between>
              <v-text-field
                placeholder="Role guard"
                disabled
                v-model="guardName"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-btn color="primary" @click="saveNew">Save</v-btn>
          <v-btn flat @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <AppMainDialog :open="dialogOpen" :message="dialogMessage" @closedialog="dialogOpen = false"></AppMainDialog>
  </div>
</template>

<script>
  import CrudAPI from '@/api/resources/crud'
  import AppMainDialog from '@/components/AppMainDialog'
  import AddButtonMixins from '@/mixins/AddButton'

  export default {
    components: { AppMainDialog },
    mixins: [ AddButtonMixins ],
    data () {
      return {
        resources: 'roles',
        dialog: false,
        modelName: '',
        guardName: 'web',
        dialogMessage: '',
        dialogOpen: false
      }
    },
    methods: {
      saveNew () {
        let payload = {
          name: this.modelName,
          guard_name: this.guardName
        }

        let result = CrudAPI.dfsResourceStore(this.resources, payload)

        result.then(this.saveNewSuccess, this.saveNewError)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// AddRoleButton.vue?09b5b66c